import React, { useEffect } from "react";
import MyRoutes from "./routes/MyRoutes";
import { theme } from "../src/themes/theme";
import { ThemeProvider } from "@mui/material";
import AOS from "aos";
import "aos/dist/aos.css";
import SnackbarComponent from "./components/Toaster/Snackbar";
import { Provider } from "react-redux";
import store from "./redux/store/store";
import ReactGA from "react-ga4";

import { PersistGate } from "redux-persist/integration/react";
import { persistor } from "./redux/store/store";

function App() {
  // TODO: This MEASUREMENT ID will be updated once client would provide us Google account
  // Guarded: this runs directly in the render body (not an effect), so it
  // executes on every renderToString call too. react-ga4 reaches for
  // `window`/`gtag` internally, which don't exist on the server - initialize
  // it only in the browser, where analytics are actually meaningful anyway.
  if (typeof window !== "undefined") {
    ReactGA.initialize("G-G6J70MDKKL");
  }

  useEffect(() => {
    AOS.init();
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.userway.org/widget.js";
    script.async = true;
    script.setAttribute("data-account", "LF0KRrxmEx");
    script.setAttribute("data-position", "3");
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>
          <MyRoutes />
          <SnackbarComponent />
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
// import React from "react"
// import MyRoutes from "./routes/MyRoutes";
// import {theme} from '../src/themes/theme'
// import { ThemeProvider } from "@mui/material";
// import "./chartConfig"

// function App() {

//   return (
//      <ThemeProvider theme={theme}>
//       <MyRoutes />
//      </ThemeProvider>
//     );
// }

// export default App;
